<template>
    <form
        action=""
        @submit.prevent="handleSubmit"
    >
        <div class="row">
            <div class="col">
                <label
                    for="type"
                    class="label"
                >Type</label>
                <select
                    name="type"
                    id=""
                    v-model="form.type"
                    class="form-control"
                >
                    <option
                        v-for="type in types"
                        :key="type.value"
                        :value="type.value"
                    >
                        {{ type.label }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label
                    for="customer"
                    class="label"
                >Customer</label>
                <customer-search @change="setCustomer" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label
                    for="site"
                    class="label"
                >Site</label>
                <select 
                    v-model="form.site_id"
                    class="form-control"
                > 
                    <option :value="null">
                        Select site
                    </option>
                    <option 
                        v-for="site in sites" 
                        :key="site.id"
                        :value="site.id"
                    >
                        {{ site.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex">
                <button
                    class="btn btn-primary ml-auto"
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import {save} from "../../../services/TaskService";
import UsesErrors from "../../../mixins/UsesErrors";
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';
import CustomerSearch from "../../CustomerSearch.vue";
import SitesService from '../../../services/SitesService';
export default {
    components: {
        CustomerSearch,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    data() {
        return {
            form: {
                type: window.TaskTypes[0].value,
                site_id: null,
            },
            sites: [],
        };
    },
    emits: ["saved"],
    computed: {
        types() {
            return window.TaskTypes;
        },
    },
    methods: {
        handleSubmit() {
            this.clearErrors();
            save(this.form).then(({data}) => {
                this.setInfoMessage('Task saved successfully');
                this.$emit("saved");
            }).catch(err => {
                this.captureRequestErrors(err);
                this.showErrorMessage('Failed to save task, check for errors');
            });
        },
        setCustomer (customer) {
            this.form.customer_id = customer ? customer.id : null;
            this.site_id = null;
            this.sites = customer ? customer.sites : [];
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/task-manager/NewTaskForm.vue